import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContext } from 'components/lib';
import styles from './onboarding.module.css';
import axios from 'axios';

export const OnboardingView = () => {
  const { user, update } = useContext(AuthContext);
  const [companyName, setCompanyName] = useState('');
  const [isAccountingFirm, setIsAccountingFirm] = useState(false);
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const updatedUser = {
      ...user,
      // accounts: user.accounts.map((account, index) => 
      // index === 0 ? { ...account, name: companyName } : account
      // ),
      is_firm: isAccountingFirm,
    };
    update(updatedUser);

    try {
      await axios.post('/api/account/onboarding', {
        companyName,
        isAccountingFirm
      });
      await axios.patch('/api/user', { onboarded: true });
      const redirectPath = '/home';
      history.push(redirectPath);
    } catch (error) {
      console.error('Failed to update account:', error);
    }
  };

  return (
    <div className={styles['onboarding-container']}>
      <h1 className={styles['onboarding-title']}>Welcome to LedgerView!</h1>
      <form className={styles['onboarding-form']} onSubmit={handleSubmit}>
        <div className={styles['form-group']}>
          <label className={styles['form-label']}>
            Company Name:
            <input
              type="text"
              className={styles['form-input']}
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
            />
          </label>
        </div>
        <div className={styles['form-group']}>
          <label className={styles['form-label']}>
            Are you an accounting or bookkeeping firm that services clients?
            <select
              className={styles['form-select']}
              value={isAccountingFirm ? 'yes' : 'no'}
              onChange={(e) => setIsAccountingFirm(e.target.value === 'yes')}
            >
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </label>
        </div>
        <button type="submit" className={styles['form-button']}>Continue</button>
      </form>
    </div>
  );
};